import { render, staticRenderFns } from "./QuotaData.vue?vue&type=template&id=5d54b87c&scoped=true"
import script from "./QuotaData.vue?vue&type=script&lang=js"
export * from "./QuotaData.vue?vue&type=script&lang=js"
import style0 from "./QuotaData.vue?vue&type=style&index=0&id=5d54b87c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d54b87c",
  null
  
)

export default component.exports